import React, { useContext, useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import MenuIcon from "../../components/icons/MenuIcon";
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";
import ListIcon from "../../components/icons/ListIcon";
import FilterIcon from "../../components/icons/FilterIcon";
import { getDataWithToken } from "../../services/GetDataService";
import { AuthContext } from "../../context/AuthContext";
import moment from "moment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { postDataWithToken } from "../../services/PostDataService";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import PulseLoader from "react-spinners/PulseLoader";
import CountryList from "../CountryList";
import { useSnackbar } from "notistack";
import InvoiceIcon from "../../components/icons/InvoiceIcon";
import CardIcon from "../../components/icons/CardIcon";
import CardsIcon from "../../components/icons/CardsIcon";
const useStyles = makeStyles((theme) => ({
  breadcrumbsStyle: {
    // "& li a": {
    //   textDecoration: "none",
    //   fontSize: "14px",
    //   color: theme.palette.text.main,
    // },
    // "& li:last-child": {
    //   "& a": {
    //     color: theme.palette.text.fade,
    //     cursor:"default"
    //   },
    // },
  },
}));

const InvoiceList = () => {
  const theme = useTheme();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { login, admin_panel_user, logout } = useContext(AuthContext);
  const [invoiceList, setInvoiceList] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoiceMessage, setInvoiceMessage] = useState("");
  const [page, setPage] = useState(2);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [invoiceId, setInvoiceId] = useState("");
  const [loading, setLoading] = useState(false);
  const [cardList, setCardList] = useState([]);
  const [cardMessage, setCardMessage] = useState("");
  const [defaultLoading, setDefaultLoading] = useState(false);
  const [loadingCardId, setLoadingCardId] = useState("");
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const getCardList = async () => {
    setLoading(true);
    setCardList([]);
    let cards = await getDataWithToken(
      `getCardList?storeId=${admin_panel_user.selectedStoreId}`,
      admin_panel_user,
      logout
    );

    if (cards.data.status) {
      if (cards.data?.data?.cards.length > 0) {
        setCardList(cards.data.data.cards);
        // setStoreId(storeId);
      } else {
        setCardMessage(cards.data.message);
      }
    } else {
      setCardMessage(cards.data.message);
    }
    setLoading(false);
  };
  const handlePayment = async (row) => {
    setDefaultLoading(true);
    setLoadingCardId(row.cardId);

    let data = {
      storeId: admin_panel_user.selectedStoreId,
      invoiceId: invoiceId,
      cardId: row.cardId,
    };

    let response = await postDataWithToken(
      "payInvoice",
      data,
      admin_panel_user,
      logout
    );

    if (response.data.code === 200) {
      // setTimeout(getData, 2000);
      // handleSnakbarOpen(response.data.message, "success");
      // handleClose();
      setTimeout(function () {
        getData();
        handleSnakbarOpen(response.data.message, "success");
        handleClose();
        setDefaultLoading(false);
        setLoadingCardId("");
      }, 2000);
    } else {
      handleSnakbarOpen(response.data.message, "error");
      setDefaultLoading(false);
      setLoadingCardId("");
    }
  };
  const showOtherCardLogo = (cardType) => {
    if (!["american express", "visa", "mastercard"].includes(cardType)) {
      return (
        <Button
          disabled
          style={{
            textAlign: "center",
            padding: "10px 20px",
            background: "#434343",
            // width: "180px",
            borderRadius: "6px",
            position: "absolute",
            right: "40px",
            top: "40px",
            color: "#fff",
          }}
        >
          {cardType}
        </Button>
      );
    } else if (cardType === "american express") {
      return (
        <img
          src="/images/amex.png"
          alt="logo"
          style={{
            position: "absolute",
            right: "40px",
            top: "40px",
          }}
        />
      );
    } else if (cardType === "visa") {
      return (
        <img
          src="/images/visa.png"
          alt="logo"
          style={{
            position: "absolute",
            right: "40px",
            top: "40px",
          }}
        />
      );
    } else if (cardType === "mastercard") {
      return (
        <img
          src="/images/master.png"
          alt="logo"
          style={{
            position: "absolute",
            right: "40px",
            top: "40px",
          }}
        />
      );
    }
    //   row.cardType.toLowerCase() === "visa"
    //     ? `url(/images/visa_card.png)`
    //     : row.cardType.toLowerCase() === "mastercard"
    //     ? `url(/images/master_card.png)`
    //     : row.cardType.toLowerCase() === "american express"
    //     ? `url(/images/american_express_card.png)`
    //     : `url(/images/default_card.png)`,
  };
  const handleClickOpen = (id) => {
    getCardList();
    setInvoiceId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const pageLoading = () => {
    let rows = [];

    for (let i = 0; i < 25; i++) {
      let cells = [];

      for (let j = 0; j < 7; j++) {
        cells.push(
          <TableCell key={j} sx={{ py: 1.5 }}>
            <Skeleton></Skeleton>
          </TableCell>
        );
      }

      rows.push(<TableRow key={i}>{cells}</TableRow>);
    }

    return rows;
  };
  const pageLoading2 = () => {
    let content = [];

    for (let i = 0; i < 4; i++) {
      content.push(
        <Grid item lg={3} xl={3}>
          <Skeleton
            variant="rectangular"
            height={240}
            sx={{ borderRadius: "12px" }}
          />
        </Grid>
      );
    }
    return content;
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getData = async () => {
    setInvoiceLoading(true);
    setInvoiceList([]);
    setInvoiceMessage("");

    let data = {
      storeId: admin_panel_user.selectedStoreId,
    };
    let invoice = await postDataWithToken(
      "invoiceList",
      data,
      admin_panel_user,
      logout
    );

    if (invoice.data.status) {
      if (invoice.data.data.bills.length > 0) {
        setInvoiceList(invoice.data.data.bills);
      } else {
        setInvoiceMessage(invoice.data.message);
      }
    } else {
      setInvoiceMessage(invoice.data.message);
    }
    setInvoiceLoading(false);
  };
  const showActionButtons = (row) => {
    // {
    //   row.paymentStatus ? (
    //     <Button
    //       variant="contained"
    //       disableElevation
    //       color="info"
    //       sx={{
    //         borderRadius: "100px",
    //         minWidth: "130px",
    //       }}
    //       component={Link}
    //       target="_blank"
    //       to={row.stripeInvoiceUrl}
    //     >
    //       Download Receipt
    //     </Button>
    //   ) : (
    //     <Button
    //       variant="contained"
    //       disableElevation
    //       sx={{ borderRadius: "100px", minWidth: "165px" }}
    //       onClick={() => handleClickOpen(row._id)}
    //     >
    //       Pay Now
    //     </Button>
    //   );
    // }
    if (row.invoiceNumber === null || row.invoiceNumber === undefined) {
      return (
        <Button
          variant="contained"
          disableElevation
          color="info"
          disabled
          sx={{
            borderRadius: "100px",
            minWidth: "182px",
          }}
          component={Link}
          // target="_blank"
          // to={row.invoicePDF}
        >
          No Bill Available
        </Button>
      );
    } else if (row.paymentStatus) {
      if (row.invoicePDF === null || row.invoicePDF === undefined) {
        return (
          <Button
            variant="contained"
            disableElevation
            color="info"
            disabled
            sx={{
              borderRadius: "100px",
              minWidth: "182px",
            }}
            component={Link}
            // target="_blank"
            // to={row.invoicePDF}
          >
            Processing Payment
          </Button>
        );
      } else {
        return (
          <Button
            variant="contained"
            disableElevation
            color="info"
            sx={{
              borderRadius: "100px",
              minWidth: "182px",
            }}
            component={Link}
            target="_blank"
            to={row.invoicePDF}
          >
            Download Receipt
          </Button>
        );
      }
    } else {
      return (
        <Button
          variant="contained"
          disableElevation
          sx={{ borderRadius: "100px", minWidth: "182px" }}
          onClick={() => handleClickOpen(row._id)}
        >
          Pay Now
        </Button>
      );
    }
  };
  useEffect(() => {
    getData();

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [admin_panel_user.selectedStoreId]);
  return (
    <div>
      <Paper sx={{ py: 1, px: 3, mb: 3 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs="auto">
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs="auto">
                {" "}
                <Avatar
                  sx={{
                    width: 44,
                    height: 44,
                    bgcolor: `${theme.palette.primary.light}`,
                  }}
                >
                  <InvoiceIcon color={theme.palette.primary.main} />
                </Avatar>
              </Grid>
              <Grid item xs="auto">
                <Typography
                  variant="base"
                  color="text.main"
                  sx={{ fontWeight: 500 }}
                >
                  Invoice List
                </Typography>

                {/* <Breadcrumbs
                  aria-label="breadcrumb"
                  // className={classes.breadcrumbsStyle}
                >
                  <Link to="/dashboard">Dashboard</Link>

                  <Link to="#">List of Invoice</Link>
                </Breadcrumbs> */}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs="auto">
            <Breadcrumbs
              aria-label="breadcrumb"
              // className={classes.breadcrumbsStyle}
            >
              <Link to="/dashboard">Dashboard</Link>

              <Link to="#">List of Invoice</Link>
            </Breadcrumbs>
          </Grid>
        </Grid>
      </Paper>
      <Paper sx={{ p: 3, pb: 0 }}>
        <TableContainer sx={{ maxHeight: "calc(100vh - 340px)" }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  Invoice Number
                </TableCell>
                <TableCell>Duration</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">Attempted</TableCell>
                <TableCell align="center">Verified</TableCell>
                <TableCell align="center">Amount</TableCell>

                <TableCell align="center" sx={{ width: "220px" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!invoiceLoading &&
                invoiceList.length > 0 &&
                invoiceList.map((row, i) => (
                  <TableRow
                  // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell  style={{ whiteSpace: "nowrap" }}>
                      {row.invoiceNumber === undefined
                        ? "No Invoice Available"
                        : row.invoiceNumber}
                    </TableCell>
                    <TableCell
                    // sx={{
                    //   color: `${theme.palette.primary.main}`,
                    //   fontWeight: 500,
                    // }}
                    >
                      {moment(row.startDate).format("DD MMM YYYY")} -{" "}
                      {moment.utc(row.endDate).format("DD MMM YYYY")}
                    </TableCell>
                    {row.paymentStatus ? (
                      <TableCell
                        align="center"
                        sx={{
                          color: `${theme.palette.success.main}`,
                          fontWeight: 500,
                        }}
                      >
                        Paid
                      </TableCell>
                    ) : (
                      <TableCell
                        align="center"
                        sx={{
                          color: `${theme.palette.warning.main}`,
                          fontWeight: 500,
                        }}
                      >
                        Pending
                      </TableCell>
                    )}

                    <TableCell align="center">{row.totalSubmission}</TableCell>
                    <TableCell align="center">{row.totalVerified}</TableCell>
                    <TableCell align="center">
                      $ {(row.totalBillAmount / 100).toFixed(2)}
                    </TableCell>

                    <TableCell align="center">
                      {showActionButtons(row)}
                      {/* {row.paymentStatus ? (
                        <Button
                          variant="contained"
                          disableElevation
                          color="info"
                          sx={{
                            borderRadius: "100px",
                            minWidth: "130px",
                            // background: theme.palette.info.main,
                          }}
                          component={Link}
                          target="_blank"
                          // to={row.stripeInvoicePDF}
                          to={row.stripeInvoiceUrl}
                        >
                          Download Receipt
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          disableElevation
                          sx={{ borderRadius: "100px", minWidth: "165px" }}
                          onClick={() => handleClickOpen(row._id)}
                          // component={Link}
                          // target="_blank"
                          // to={row.stripeInvoiceUrl}
                        >
                          Pay Now
                        </Button>
                      )} */}
                    </TableCell>
                  </TableRow>
                ))}
              {!invoiceLoading && invoiceList.length < 1 ? (
                <TableRow>
                  <TableCell colSpan={8} style={{ textAlign: "center" }}>
                    <strong>
                      {invoiceMessage.length > 0
                        ? invoiceMessage
                        : "No data found"}{" "}
                    </strong>
                  </TableCell>
                </TableRow>
              ) : null}
              {invoiceLoading && pageLoading()}
            </TableBody>
          </Table>
        </TableContainer>
        {/* {invoiceList.length > 0 && (
          <TablePagination
            component="div"
            count={100}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )} */}
      </Paper>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
      >
        <DialogTitle id="alert-dialog-title" sx={{ mb: 2 }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs="auto">
              <Grid container alignItems="center" spacing={1}>
                <Grid item xs="auto">
                  {" "}
                  {/* <Avatar
                    sx={{
                      width: 44,
                      height: 44,
                      bgcolor: `${theme.palette.success.light}`,
                    }}
                  >
                    <ListIcon color={theme.palette.success.main} />
                  </Avatar> */}
                  <Avatar
                    sx={{
                      width: 44,
                      height: 44,
                      bgcolor: `${theme.palette.primary.light}`,
                    }}
                  >
                    <CardsIcon color={theme.palette.primary.main} />
                  </Avatar>
                </Grid>
                <Grid item xs="auto">
                  <Typography
                    variant="base"
                    color="text.main"
                    sx={{ fontWeight: 500 }}
                  >
                   Select Payment Card 
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs="auto">
              <IconButton
                variant="outlined"
                disableElevation
                onClick={handleClose}
                style={{
                  background: theme.palette.border.main,
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ minWidth: "1200px" }}>
          <Grid container alignItems="center" spacing={3}>
            {!loading && cardList.length < 1 && (
              <Grid item xs={12}>
                {cardMessage}
              </Grid>
            )}
            {!loading &&
              cardList.length > 0 &&
              cardList.map((row, i) => (
                <Grid item lg={4} xl={4} key={i}>
                  {" "}
                  <Paper
                    sx={{
                      borderRadius: "12px",
                      boxShadow:
                        "0px 2px 3px 0px rgba(0, 0, 0, 0.10), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)",
                      background: row.isDefault ? "#F0FAE8" : "#fff",
                    }}
                  >
                    <Box
                      sx={{
                        height: "180px",
                        background: `url(/images/Card_Lines.svg), linear-gradient(180deg, #F7F9FF 0%, #E4E4E4 100%)`,
                        borderRadius: "12px",
                        position: "relative",
                      }}
                    >
                      <img
                        src="/images/Chip.png"
                        alt="logo"
                        style={{
                          position: "absolute",
                          left: "28px",
                          top: "62px",
                        }}
                      />
                      {showOtherCardLogo(row.cardType.toLowerCase())}
                      <Typography
                        variant="h6"
                        color="#000"
                        sx={{
                          pl: 6.5,
                          pt: 16,
                          fontSize: "18px",
                          fontWeight: 400,
                        }}
                      >
                        **** &nbsp;&nbsp;&nbsp;&nbsp;****
                        &nbsp;&nbsp;&nbsp;&nbsp;**** &nbsp;&nbsp;&nbsp;&nbsp;
                        {row.last4Digit}
                      </Typography>
                    </Box>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ px: 2.5, py: 1.5 }}
                    >
                      <Grid item xs="base">
                        <Typography
                          variant="small"
                          color="#222"
                          sx={{ fontWeight: 600 }}
                        >
                          {/* {row.country} */}
                          {
                            CountryList.find(
                              (country) => country.code === row.country
                            ).name
                          }
                        </Typography>
                      </Grid>
                      <Grid item xs="auto">
                        <Button
                          variant="contained"
                          color="success"
                          disableElevation
                          sx={{
                            textTransform: "none",
                            fontSize: "12px",
                            paddingRight: "12px",
                            paddingLeft: "12px",
                            borderRadius: "100vw",
                            minWidth: "120px",
                            minHeight: "30px",
                          }}
                          size="small"
                          disabled={defaultLoading}
                          onClick={() => handlePayment(row)}
                        >
                          {row.cardId !== loadingCardId && "PAY"}
                          {/* {defaultLoading === false && "PAY"} */}
                          <PulseLoader
                            color={theme.palette.success.main}
                            loading={
                              defaultLoading && row.cardId === loadingCardId
                            }
                            size={10}
                            speedMultiplier={0.5}
                          />{" "}
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              ))}
            {loading && pageLoading2()}
          </Grid>
        </DialogContent>
        {/* <DialogActions>
          <Button
            variant="outlined"
            disableElevation
            autoFocus
            startIcon={<CloseIcon fontSize="small" />}
            onClick={handleClose}
            sx={{ minWidth: "160px" }}
          >
            Close  
          </Button>
        </DialogActions> */}
      </Dialog>
    </div>
  );
};

export default InvoiceList;
